import React from 'react';

import { Box } from '../../../Box';
import Link from '../../../Link';

import { SocialIconProps } from '../../../SocialIcons';

import { SocialIconBox } from './styles';

import {
  FacebookIcon,
  YouTube20Icon,
  Twitter20Icon,
  InstagramIcon
} from '../../../SocialIcons';

const icons = [
  {
    id: 'Facebook',
    url: 'https://www.facebook.com/GreenlightCard/'
  },
  {
    id: 'YouTube',
    url: 'https://www.youtube.com/c/GreenlightCard'
  },
  {
    id: 'Twitter',
    url: 'https://twitter.com/GreenlightCard'
  },
  {
    id: 'Instagram',
    url: 'https://www.instagram.com/greenlightcard/'
  }
];

const Icon = ({ iconId, ...props }: SocialIconProps & { iconId: string }) => {
  switch (iconId) {
    case 'Facebook':
      return <FacebookIcon {...props} />;
    case 'YouTube':
      return <YouTube20Icon {...props} />;
    case 'Twitter':
      return <Twitter20Icon {...props} />;
    case 'Instagram':
      return <InstagramIcon {...props} />;
    default:
      return null;
  }
};

export function SocialLinks() {
  return (
    <Box
      flex="1 0 auto"
      data-section-id="social-links"
      data-testid="social-links"
    >
      <SocialIconBox marginTop="ml">
        {icons.map(({ id, url }) => (
          <Link
            key={id}
            href={url}
            target="_blank"
            rel="noreferrer"
            aria-label={id}
          >
            <Icon
              iconId={id}
              colour="socialIconSupplementary"
              hoverColor="socialIconLightHover"
            />
          </Link>
        ))}
      </SocialIconBox>
    </Box>
  );
}
